import actionTypes from 'SRC/modules/redux/actionTypes'

export const setProfileAdsQuery = query => ({
  type: actionTypes.SET_PROFILE_ADS_QUERY,
  payload: query
})
